import { ThreeEvent } from "@react-three/fiber";

type PointerHandler = (event: ThreeEvent<PointerEvent>) => void;

export type WallInteractionHandlers = {
  onPointerDown?: PointerHandler;
  onPointerEnter?: PointerHandler;
  onPointerMove?: PointerHandler;
  onPointerLeave?: PointerHandler;
};

const handlerRegistry = new Map<string, WallInteractionHandlers>();

export const registerWallInteractionHandlers = (
  wallId: string,
  handlers: WallInteractionHandlers,
): (() => void) => {
  handlerRegistry.set(wallId, handlers);
  return () => {
    const current = handlerRegistry.get(wallId);
    if (current === handlers) {
      handlerRegistry.delete(wallId);
    }
  };
};

export const getWallInteractionHandlers = (wallId: string): WallInteractionHandlers | undefined => {
  return handlerRegistry.get(wallId);
};
